import { useEffect, useMemo, useState } from 'react';
import '/assets/styles/pages/web-menu.scss';

// Partials
import Loader from '/views/partials/loader';
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Sections
import WebPageHeader from '/views/sections/web-page-header';
import WebMenuLanding from '/views/sections/web-menu-landing';

// Services
import menuServices from '/services/menu';

// Context
import { useApplication } from '/utilities/application';
import { useBranchSelection } from '/utilities/branch-selection';
import { useNavigator, useParams } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useTranslation } from '/utilities/i18n';

const WebMenu = () => {
	const { isApplication } = useApplication();
	const { submitMenuUrl, initialized } = useBranchSelection();
	const { branchSlug } = useParams(['webMenuLanding', 'webMenu']);
	const { openModal } = useModals();
	const { redirect, activeRoute } = useNavigator();
	const { t } = useTranslation();
	const [categories, setCategories] = useState(null);

	const isLanding = useMemo(() => activeRoute?.key === 'webMenuLanding', [activeRoute]);

	useEffect(() => {
		if (!isApplication && branchSlug) {
			setCategories(null);
			menuServices
				.getMenuCategories(branchSlug)
				.then((payload) => {
					setCategories(payload);
				})
				.catch((feedback) => {
					openModal('message', { feedback });
				});
		}
	}, [isApplication, branchSlug, initialized]);

	useEffect(() => {
		if (isApplication && branchSlug) {
			submitMenuUrl(window.location.href).then(() => {
				redirect('menu', null, { replace: true });
			});
		}
	}, [branchSlug, isApplication]);

	return (
		<>
			<Loader full solid dark loading={isApplication} />
			{!isLanding ? (
				<>
					<WebPageHeader className="product-header" backLink={false} title={t('Menü')} />

					<div className="menu-container loader-container">
						<Loader dark loading={!categories} />
						{categories && (
							<div className="menu-categories wrapper">
								<strong className="categories-title">{t('Kategoriler')}</strong>

								<ul className="categories-list">
									{categories.map((category) => (
										<li className="list-category" key={category.id}>
											<Link
												href="webMenuCategory"
												params={{ branchSlug, id: category.id }}
												className="category-link"
											>
												<div className="category-imagewrap">
													<Img src={category.image} className="category-image" />
												</div>
												<div className="category-textarea">
													<strong className="category-title">{category.title}</strong>
													{!!category.product_count && (
														<span className="category-count">
															{t('{{count}} Ürün', { count: category.product_count })}
														</span>
													)}
												</div>
											</Link>
										</li>
									))}
								</ul>
							</div>
						)}
					</div>
				</>
			) : (
				<WebMenuLanding />
			)}
		</>
	);
};

export default WebMenu;
